<!--

 * @LastEditors: JumpingBirds
 * @LastEditTime: 2020-09-09 13:28:45
-->
<template>
  <footer>
    <div class="footer box">
      <div class="link-box">
        <ul id='linklist'>
          <li>
            <span>友情链接：</span>
          </li>
          <li v-for="(item,index) in relatedWebsitesList" :key="index">
            <a  :href="item.websiteAddress"  target="_blank">{{item.name}}</a>
          
          </li>
          <!-- <li>
            <a>中国水利网</a>
          </li>
          <li>
            <a>长江新闻网</a>
          </li>
          <li>
            <a>水与中国</a>
          </li>
          <li>
            <a>北京市水务局</a>
          </li>
          <li>
            <a>河南省水利局</a>
          </li>
          <li>
            <a>中国水文信息网</a>
          </li>
          <li>
            <a>黄河水利委员会</a>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="clear"></div>
    <div class="footer-line"></div>
    <div class="box">
      <div class="end-nav">
        <img src="../../assets/images/dzjg.png" alt />
        <p>联系电话：0371-65510463<span style="margin-left: 10px">地址：郑州市丰产路93号</span><span style="margin-left: 10px">投稿信箱：hnsbzxxk@163.com</span></p>
        <p>河南省水土保持监测总站@版权所有</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { getRelatedWebsitesPage } from "../../api/index";
export default {
  name: "Footer",
  props: {
    //msg: String
  },
  data: function() {
    return {
      relatedWebsitesList: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getRelatedWebsitesPage({
        size: 8
      }).then(res => {
        this.relatedWebsitesList = res.data.records;
        console.log(res, "res=====");
      });
    }
  }
};
</script>
<style scoped>
/**:last-child 友情链接最后一个元素高亮 */
#linklist li:last-child a {
 color: rgba(255,177,0,1);
 font-weight: bold ;

}
</style>



// WEBPACK FOOTER //
// src/views/layout/Footer.vue